import { render, staticRenderFns } from "./SelectAssessmentItemsInput.vue?vue&type=template&id=7617bcc4&scoped=true"
import script from "./SelectAssessmentItemsInput.vue?vue&type=script&lang=js"
export * from "./SelectAssessmentItemsInput.vue?vue&type=script&lang=js"
import style0 from "./SelectAssessmentItemsInput.vue?vue&type=style&index=0&id=7617bcc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7617bcc4",
  null
  
)

export default component.exports